import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';
import { AddonFormData } from '@src/types';
import { Input } from '@features/ui';

interface AddonEvalDiscountProps {
  control: Control<AddonFormData>;
}
export const AddonEvalDiscount: FC<AddonEvalDiscountProps> = ({ control }) => {
  return (
    <>
      <Controller
        control={control}
        name="addon_discount_percent"
        render={({ field }) => (
          <div className={'flex flex-col gap-3.5 flex-1 mt-6'}>
            <p>Discount (%)</p>
            <Input
              className={'w-[80px]'}
              placeholder={'0'}
              textSize={'xs'}
              type={'number'}
              variant={'secondary'}
              {...field}
            />
          </div>
        )}
      />
      <Controller
        control={control}
        name="addon_valid_for_days"
        render={({ field }) => (
          <div className={'flex flex-col gap-3.5 flex-1 mt-6'}>
            <p>Valid for (days)</p>
            <Input
              className={'w-[80px]'}
              placeholder={'0'}
              textSize={'xs'}
              type={'number'}
              variant={'secondary'}
              {...field}
            />
          </div>
        )}
      />
    </>
  );
};
